import "./BatchEditorLeftNav.css";
import {
  newImageIcon,
  backgroundIcon,
  resizeIcon,
  aiShadowIcon,
  aiUpscaleIcon,
  aiEnhanceIcon,
  aiRelightIcon,
  moreIcon,
} from "../../icons/assets";
import { useState, useEffect } from "react";

const BatchEditorLeftNav = (props) => {
  const { activeMenuIndex, setActiveMenuIndex } = props;
  const [activeIndex, setActiveIndex] = useState(activeMenuIndex || 0);

  useEffect(() => {
    if (activeMenuIndex !== undefined && activeMenuIndex !== activeIndex) {
      setActiveIndex(activeMenuIndex);
    }
  }, [activeMenuIndex]);

  useEffect(() => {
    if (setActiveMenuIndex && activeIndex !== activeMenuIndex) {
      setActiveMenuIndex(activeIndex);
    }
  }, [activeIndex]);

  const menuItems = [
    { icon: newImageIcon, label: "Batch", iconClass: "icon icon--subject" },
    { icon: resizeIcon, label: "Resize", iconClass: "icon" },
    { icon: backgroundIcon, label: "Background", iconClass: "icon" },
    { icon: aiShadowIcon, label: "AI Shadow", iconClass: "icon" },
    { icon: aiEnhanceIcon, label: "AI Expand", iconClass: "icon" },
    { icon: aiUpscaleIcon, label: "AI Upscale", iconClass: "icon" },
    { icon: aiRelightIcon, label: "AI Relight", iconClass: "icon" },
    { icon: moreIcon, label: "More", iconClass: "icon" },
  ];

  return (
    <div className="editor-page__left-menu">
      {menuItems.map((item, idx) => (
        <div
          key={item.label}
          className={`editor-page__left-menu__item${activeIndex === idx ? " active" : ""}`}
          onClick={() => setActiveIndex(idx)}
        >
          <img className={item.iconClass} src={item.icon} alt={item.label} />
          <p>{item.label}</p>
        </div>
      ))}
    </div>
  );
};

export default BatchEditorLeftNav;
